/** Derive the Socket.IO server origin from a REST API base URL (strips `/api/v1`, etc.). */
export function getSocketServerUrl(apiBaseUrl, fallbackOrigin = 'http://localhost:4000') {
    if (!apiBaseUrl || apiBaseUrl.startsWith('/')) {
        if (typeof globalThis !== 'undefined') {
            const g = globalThis;
            if (g.location?.origin)
                return g.location.origin;
        }
        return fallbackOrigin;
    }
    try {
        const url = new URL(apiBaseUrl);
        const stripped = url.pathname
            .replace(/\/api\/v\d+\/?$/i, '')
            .replace(/\/api\/?$/i, '')
            .replace(/\/$/, '');
        url.pathname = stripped || '/';
        url.search = '';
        url.hash = '';
        return `${url.protocol}//${url.host}`;
    }
    catch {
        const withoutApi = apiBaseUrl.replace(/\/api\/v\d+\/?$/i, '').replace(/\/$/, '');
        return withoutApi || fallbackOrigin;
    }
}
//# sourceMappingURL=socket.js.map